import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ALLOWSCHEDULETRANSFER, BENEID, PAYMENTTYPE, REFERENCE_KEY, REQUESTREFERENCE, REQUESTTYPE } from '@common/constants';
import { ETransferServiceCode, IResultNavigationDetails, IResultPageState } from '@common/models';
import { ResultPageService, ResultService } from '@common/services';
import { BaseFpxFormComponent } from '@common/utils';
import { ILoanInfo } from 'src/app/models/loan-details.model';
import { ServiceStock } from 'src/app/service-stock.service';
import { LoanService } from 'src/app/services/loans/loan.service';
import { LoansValidationService } from 'src/app/services/loans/loans.validator.service';
import { ServiceRequestHistoryService } from 'src/app/services/service-request-history/service-request-history.service';
import { IResultDataModel } from './models/transfer-beneficiary.model';
import { TransferBeneficiaryHelper, TransferBeneficiaryState } from './services/transfer-beneficiary.helper';

@Component({
  selector: 'app-transfer-beneficiary',
  templateUrl: './transfer-beneficiary.component.html',
  styleUrls: ['./transfer-beneficiary.component.scss'],
  providers: [
    TransferBeneficiaryHelper,
    LoansValidationService
  ]
})
export class TransferBeneficiaryComponent extends BaseFpxFormComponent<TransferBeneficiaryHelper, TransferBeneficiaryState> {
  requestReference: any;
  

  constructor(
    private services: ServiceStock,
    _formBuilder: FormBuilder,
    private _router: Router,
    public _transferBeneficiaryHelper: TransferBeneficiaryHelper,
    public _loanService: LoanService,
    private _loansValidationService: LoansValidationService,
    private _resultService: ResultService,
    private _serviceRequestHistoryService: ServiceRequestHistoryService
  ) {
    super(_formBuilder, _router, _transferBeneficiaryHelper);
  }

  override doPreInit() {
    this.initializeForm();
    this.requestReference = this._serviceRequestHistoryService.getTrackerDetails()?.requestReference;
    if (this.requestReference) {
      this.formGroup.disable();
      this.state.disableMode = true;
      this._transferBeneficiaryHelper.fetchTransferDetails(this._serviceRequestHistoryService.getTrackerDetails().paymentType, this.requestReference, this.formGroup);
    }
  }

  override doPostInit() {
    this._transferBeneficiaryHelper.transferService.populateFavDataFormIfSameNavUrl?.asObservable().subscribe((res) => {
      console.log(res)
      this.initializeForm(res);
      this.formGroup.enable({ emitEvent: false });
      this.state.isComponentInitialLoad = false;
    })
    this.state.isComponentInitialLoad = false;
  }

  protected doDestroy(): void {
    this._transferBeneficiaryHelper.resetState();
  }

  initializeForm(loadDataFromFav?) {
    this.state.isComponentInitialLoad = true;
    this.state.fromAccountNumber = loadDataFromFav?.referenceKey ? loadDataFromFav.referenceKey : this.getRoutingParam(REFERENCE_KEY);;
    this.state.beneId = loadDataFromFav?.beneId ? loadDataFromFav.beneId : this.getRoutingParam(BENEID);
    // construct to debit account card data start
    this._transferBeneficiaryHelper.constructSelectedBene(loadDataFromFav?.selectedBene ? loadDataFromFav.selectedBene : this.getRoutingParam('selectedBene'))
    // construct to debit account card end
    this.state.paymentSystem = loadDataFromFav?.paymentType ? loadDataFromFav.paymentType : this.getRoutingParam(PAYMENTTYPE);
    if (this._serviceRequestHistoryService.getTrackerDetails()?.paymentType) this.state.paymentSystem = this._serviceRequestHistoryService.getTrackerDetails().paymentType;
    // if Swift , filter all EGP accounts from debit account start
    this._transferBeneficiaryHelper.filterEGPForSwift()
    // if Swift , filter all EGP accounts from debit account end
    let defaultBene = this.state.beneId && this.state.selectedBene ? { beneId: this.state.beneId, selectedBene: this.state.selectedBene } : "";
    // this.state.selectedBene = defaultBene;
    this.addFormControl("debitAccNo", this.state.fromAccountNumber, [Validators.required]);
    this.addFormControl("beneId", defaultBene, [Validators.required]);
    this.addFormControl("amount", "", [Validators.required], [], 'change');
    this.addFormControl("transferDate", new Date().toISOString().split('T')[0], [Validators.required]);
    this.addFormControl("remarks", "", [], [], 'change');
    this.addFormControl("isScheduled", "0", [], [], 'change');
    this.addFormControl("scheduleType", "", [], [], 'change');
    this.addFormControl("noOfInstallment", "1", []);
    this.addFormControl("endDate", '', []);
    this.addFormControl("saveAsFavorite", '0', []);

    this._transferBeneficiaryHelper.setCurrencyDropDown(this.state.fromAccountNumber);

    this.state.formGroupValue = this.getRoutingParam('formGroupValue');
    this.state.newFormData = { referenceKey: this.state.fromAccountNumber, beneId: this.state.beneId, paymentSystem: this.state.paymentSystem, amount: '', remarks: '' };
    this._transferBeneficiaryHelper.setTitle()
    this._transferBeneficiaryHelper.enableOrDisableSchedule();
    this.formGroup.controls['transferDate'].disable;
    this._transferBeneficiaryHelper.setUpBeneficiaryDetails(this.state.paymentSystem, this.state.beneId)
    this.populateFormData(loadDataFromFav,defaultBene)
  }

  populateFormData(loadDataFromFav,defaultBene) {
    this.state.formGroupValue = this.getRoutingParam('formGroupValue');
    if (this.state.formGroupValue || loadDataFromFav?.formGroupValue) {
      let debitAccNo = loadDataFromFav?.formGroupValue?.debitAccNo ? loadDataFromFav?.formGroupValue?.debitAccNo : this.state.formGroupValue?.debitAccNo;
      let beneId = loadDataFromFav?.formGroupValue?.beneId ? loadDataFromFav?.formGroupValue?.beneId : this.state.formGroupValue?.beneId;
      let amount = loadDataFromFav?.formGroupValue?.amount?.amount ? loadDataFromFav?.formGroupValue?.amount?.amount : this.state.formGroupValue?.amount?.amount;
      let currency = loadDataFromFav?.formGroupValue?.amount?.currencyCode ? loadDataFromFav?.formGroupValue?.amount?.currencyCode : this.state.formGroupValue?.amount?.currencyCode ? this.state.formGroupValue.amount?.currencyCode : "";
      let remarks = loadDataFromFav?.formGroupValue ? loadDataFromFav?.formGroupValue?.remarks : this.state.formGroupValue?.remarks;
      this.formGroup.patchValue({
        "debitAccNo": debitAccNo,
        "beneId": { beneId: beneId, selectedBene: this.state.selectedBene },
        "remarks": remarks,
        amount: {
          'amount': amount,
          'currencyCode': currency
        },
      }, { emitEvent: false });
      this.state.resetValues = { debitAccNo: debitAccNo, beneId: { beneId: beneId, selectedBene: this.state.selectedBene }, remarks: remarks, amount: { 'amount': amount, 'currencyCode': currency } }
    }
    else {
      this.formGroup.controls['debitAccNo'].patchValue(this.state.fromAccountNumber);
      this.state.resetValues = { debitAccNo: this.state.fromAccountNumber, beneId: defaultBene, remarks: '', amount: { amount: "", currencyCode: this._transferBeneficiaryHelper.getDebitAccountDetail(this.state.fromAccountNumber)[0]?.accountCurrency } }
    }

  }

  override doConfirm(formGroup: FormGroup) {
    this._transferBeneficiaryHelper.doConfirm(
      formGroup.value,
      this.state.paymentSystem,
      (res) => {
        let resultData: IResultDataModel = { 'debitAccNo': formGroup.value.debitAccNo, 'beneId': formGroup.value?.beneId?.beneId, amount: formGroup.value.amount, remarks: formGroup.value.remarks };
        this._transferBeneficiaryHelper.setUpResutPageData(true, res, resultData, formGroup.value)
        this.navigateToResultPage(this._resultService.resultPageData);
      },
      (err) => {
        let resultData: IResultDataModel = { 'debitAccNo': formGroup.value.debitAccNo, 'beneId': formGroup.value?.beneId?.beneId, amount: formGroup.value.amount, remarks: formGroup.value.remarks };
        this._transferBeneficiaryHelper.setUpResutPageData(false, err, resultData, formGroup.value)
        this.navigateToResultPage(this._resultService.resultPageData);
      }
    );
  }


  edit() {
    this.formGroup.enable({ emitEvent: false });
    this.state.favDisable = false;
    this.state.hideRemarks = false;
    this.state.disableMode=false;
  }

  reset() {
    this.formGroup.get('remarks').reset('');
    this.formGroup.get('debitAccNo').reset('', { emitEvent: false });
    this.formGroup.get('beneId').reset('');
    this.formGroup.get('isScheduled').reset('', { emitEvent: false });
    this.formGroup.get('scheduleType').reset('', { emitEvent: false });
    this.formGroup.get('noOfInstallment').reset('');
    this.formGroup.get('endDate').reset('', { emitEvent: false });
    this.formGroup.get('amount').reset('', { emitEvent: false });

    this.formGroup.patchValue({
      "debitAccNo": this.state.resetValues?.debitAccNo,
      "remarks": this.state.resetValues?.remarks ? this.state.resetValues?.remarks : '',
      "amount": this.state.resetValues?.amount,
      "beneId": this.state.resetValues?.beneId
    }, { emitEvent: false });
  }


}